import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Navbar from './components/landing/Navbar'
import Hero from './components/landing/Hero'
import Benefits from './components/landing/Benefits'
import UseCases from './components/landing/UseCases'
import CompetitiveAdvantages from './components/landing/CompetitiveAdvantages'
import PricingPlans from './components/landing/PricingPlans'
import Testimonials from './components/landing/Testimonials'
import FinalCTA from './components/landing/FinalCTA'
import Footer from './components/landing/Footer'
import CardPaymentPage from './pages/CardPaymentPage'
import PixPaymentPage from './pages/PixPaymentPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import EmailVerificationModal from './components/landing/EmailVerificationModal'
import { usePendingVerification } from './hooks/usePendingVerification'

function App() {
  const { pendingData, isLoading, clearPendingVerification, hasPendingVerification } = usePendingVerification()
  const [showVerificationModal, setShowVerificationModal] = useState(false)

  // Mostrar modal de verificação se houver verificação pendente
  useEffect(() => {
    if (!isLoading && hasPendingVerification && pendingData) {
      setShowVerificationModal(true)
    }
  }, [isLoading, hasPendingVerification, pendingData])

  const handleVerificationSuccess = () => {
    setShowVerificationModal(false)
    clearPendingVerification()
  }

  const handleVerificationClose = () => {
    setShowVerificationModal(false)
  }

  return (
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={
              <>
                <Navbar />
                <main>
                  <Hero />
                  <Benefits />
                  <UseCases />
                  <CompetitiveAdvantages />
                  <PricingPlans />
                  <Testimonials />
                  <FinalCTA />
                </main>
                <Footer />
              </>
            } />
            
            {/* Payment Pages */}
            <Route path="/pagamento/cartao" element={<CardPaymentPage />} />
            <Route path="/pagamento/pix" element={<PixPaymentPage />} />
            <Route path="/pagamento/sucesso" element={<PaymentSuccessPage />} />
          </Routes>

          {/* Modal de Verificação de Email Global */}
          {pendingData && (
            <EmailVerificationModal
              isOpen={showVerificationModal}
              onClose={handleVerificationClose}
              onSuccess={handleVerificationSuccess}
              email={pendingData.email}
            />
          )}
        </div>
      </Router>
  )
}

export default App
